import React, { useState, useMemo } from 'react';
import { useParent } from '../context/ParentContext';
import ParentAlertCard from '../components/cards/ParentAlertCard';
import ParentEmptyState from '../components/states/ParentEmptyState';
import ParentBackendPendingBanner from '../components/ParentBackendPendingBanner';
import '../components/cards/ParentAlertCard.css';
import './ParentAlerts.css';

function ParentAlerts() {
  const { allAlerts, currentAlerts, selectedStudentId, demoState, hasAlertsBackend } = useParent();
  const [filterSeverity, setFilterSeverity] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');

  const alerts = selectedStudentId === 'all' ? allAlerts : currentAlerts;

  const filtered = useMemo(() => {
    let result = [...alerts];
    if (filterSeverity !== 'all') result = result.filter(a => a.severity === filterSeverity);
    if (filterStatus !== 'all') result = result.filter(a => a.status === filterStatus);
    if (filterType !== 'all') result = result.filter(a => a.type === filterType);
    return result;
  }, [alerts, filterSeverity, filterStatus, filterType]);

  if (!hasAlertsBackend) {
    return (
      <div className="parent-alerts-page">
        <h1 className="parent-page-title">Alerts</h1>
        <ParentBackendPendingBanner
          state="pending"
          message="Alerts backend pending."
          hint="See src/parent/BACKEND_GAPS.md."
        />
      </div>
    );
  }

  if (demoState === 'empty' || alerts.length === 0) {
    return (
      <div className="parent-alerts-page">
        <h1 className="parent-page-title">Alerts</h1>
        <ParentEmptyState variant="no-alerts" />
      </div>
    );
  }

  return (
    <div className="parent-alerts-page">
      <h1 className="parent-page-title">Alerts</h1>

      <div className="parent-alerts-page__filters">
        <select value={filterSeverity} onChange={e => setFilterSeverity(e.target.value)} className="parent-filter-select" aria-label="Filter by severity">
          <option value="all">All Severities</option>
          <option value="urgent">Urgent</option>
          <option value="important">Important</option>
          <option value="watch">Watch</option>
          <option value="informational">Informational</option>
        </select>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="parent-filter-select" aria-label="Filter by status">
          <option value="all">All Statuses</option>
          <option value="new">New</option>
          <option value="reviewed">Reviewed</option>
          <option value="resolved">Resolved</option>
          <option value="muted">Muted</option>
        </select>
        <select value={filterType} onChange={e => setFilterType(e.target.value)} className="parent-filter-select" aria-label="Filter by type">
          <option value="all">All Types</option>
          <option value="overdue">Overdue</option>
          <option value="declining-activity">Declining Activity</option>
          <option value="upcoming-deadline">Upcoming Deadline</option>
          <option value="no-quiz-activity">No Quiz Activity</option>
          <option value="positive-milestone">Positive Milestone</option>
        </select>
      </div>

      <p className="parent-alerts-page__count">{filtered.length} alerts</p>

      <div className="parent-alerts-page__list">
        {filtered.map(alert => (
          <ParentAlertCard
            key={alert.id}
            alert={alert}
          />
        ))}
      </div>
    </div>
  );
}

export default ParentAlerts;
